import { UserLocation } from "@themuse/design-system/lib/main";

import {
    SearchCompany, SearchLocation, SearchState, Location
} from "interfaces/context/searchContextInterfaces";

const initialLocationList = [
    {
        label: "Remote / Flexible",
        value: "Remote / Flexible",
        latitude: null,
        longitude: null,
        remote_work_location_type: "virtual",
        id: 0,
    },
    {
        label: "New York, NY",
        value: "New York, NY",
        latitude: 40.709999084472656,
        longitude: -74.01000213623047,
        remote_work_location_type: null,
        id: 5852770
    },
    {
        label: "San Francisco, CA",
        value: "San Francisco, CA",
        latitude: 37.77492904663086,
        longitude: -122.41941833496094,
        remote_work_location_type: null,
        id: 5834763
    },
    {
        label: "Los Angeles, CA",
        value: "Los Angeles, CA",
        latitude: 34.0522346496582,
        longitude: -118.24368286132812,
        remote_work_location_type: null,
        id: 5834138
    },
    {
        label: "Boston, MA",
        value: "Boston, MA",
        latitude: 42.36008071899414,
        longitude: -71.05888366699219,
        remote_work_location_type: null,
        id: 5845716
    },
    {
        label: "Washington, DC",
        value: "Washington, DC",
        latitude: 38.90719223022461,
        longitude: -77.03687286376953,
        remote_work_location_type: null,
        id: 5831724
    },
    {
        label: "Austin, TX",
        value: "Austin, TX",
        latitude: 30.267152786254883,
        longitude: -97.74305725097656,
        remote_work_location_type: null,
        id: 5862957
    },
    {
        label: "Chicago, IL",
        value: "Chicago, IL",
        latitude: 41.87811279296875,
        longitude: -87.62979888916016,
        remote_work_location_type: null,
        id: 5838173
    },
    {
        label: "Seattle, WA",
        value: "Seattle, WA",
        latitude: 47.60620880126953,
        longitude: -122.33206939697266,
        remote_work_location_type: null,
        id: 5865100
    },
    {
        label: "Atlanta, GA",
        value: "Atlanta, GA",
        latitude: 33.74899673461914,
        longitude: -84.38798522949219,
        remote_work_location_type: null,
        id: 5837145
    }
];

export const selectedLocationSelector = (
    location: SearchLocation,
    company: SearchCompany,
    userLocation: UserLocation
) => {
    const { lat = null, lon = null } = userLocation;
    const { userSelectedLocation } = location;
    const companySet = company.userSelectedCompany === null;
    const defaultInitialSearchLocation: Location = {
        label: "",
        latitude: companySet ? lat : null,
        longitude: companySet ? lon : null,
        remote_work_location_type: null,
        value: ""
    };

    return (userSelectedLocation === null || userSelectedLocation.latitude === null)
            && userSelectedLocation?.remote_work_location_type !== "virtual"
        ? defaultInitialSearchLocation : userSelectedLocation;
};

export const locationSuggestionsSelector = (location) => {
    const { locationSuggestions } = location;
    return locationSuggestions?.length ? locationSuggestions : initialLocationList;
};

export const searchResultsSelector = (searchState: SearchState, userLocation: UserLocation) => {
    const {
        location, company, keyword, filters, userInteractions, url, preference, searchId
    } = searchState;

    const searchResultsLocation = selectedLocationSelector(location, company, userLocation);
    const locationName = searchResultsLocation?.value ?? "";
    const { latitude, longitude } = searchResultsLocation || {};
    // Checking for the userSelectedLocation value makes sure that the carmen location is not included in the request
    const latlng = location?.userSelectedLocation?.value && latitude ? `${latitude},${longitude}` : null;
    const remoteOption = searchResultsLocation?.remote_work_location_type;

    // Get company-derived parameters
    const companyName = company.userSelectedCompany?.label;
    const companyShortName = company.userSelectedCompany?.value;

    // Get category-derived parameters;
    const category = filters?.category.length === 1 ? filters?.category[0] : null;

    // Get keyword-derived parameters
    const searchKeyword = keyword.userInputValue;

    return {
        company,
        location,
        keyword,
        filters,
        locationName,
        latitude,
        longitude,
        latlng,
        remoteOption,
        companyName,
        companyShortName,
        category,
        searchKeyword,
        userInteractions,
        url,
        preference,
        searchId
    };
};
